import {
    mdiHome,
    mdiWeightLifter,
    // mdiAccountCircle,
    mdiTable,
    mdiMessageQuestionOutline,
    mdiForumOutline,
    mdiFileDocumentMultipleOutline,
    mdiShieldAccount,
    mdiStar,
    mdiFlag,
    mdiChartLine,
    mdiBullhorn,
    mdiCog,
    // mdiLogout
} from '@mdi/js'
import shotSidebarBanner from '@/assets/img/ad/shot_sidebar_banner.png'

// mdiTable
export default [
    // 'メニュー',
    [
        {
            to: '/home',
            icon: mdiHome,
            label: 'ホーム'
        },
        {
            /* to: '/training', */
            /* icon: mdiWeightLifter, */
            /* label: 'トレーニング' */
            to: '/goal-settings',
            icon: mdiFlag, // TODO: 確認必要
            label: '目標設定',
        },
        {
            to: '/mydata',
            /* icon: mdiAccountCircle, */
            icon: mdiChartLine, // TODO: 確認必要
            label: 'Myデータ'
        },
        // {
        //     to: '/event-list',
        //     icon: mdiBullhorn, // TODO: 確認必要
        //     label: 'イベント一覧',
        // },
        {
            to: '/ranking/individual/local',
            icon: mdiStar,
            label: 'ランキング',
            submenu: [
                {'個人': [
                    {
                        to: '/ranking/individual/local',
                        label: 'チーム内ランキング',
                    },
                    {
                        to: '/ranking/individual/national',
                        label: '全国ランキング',
                    },
                ]},
                {'チーム': [
                    {
                        to: '/ranking/team/national',
                        label: '全国ランキング',
                    },
                ]},
            ],
        },
        {
            to: '/note',
            icon: mdiFileDocumentMultipleOutline,
            label: 'ノート',
        },
        {
            to: '/setting',
            /* icon: mdiAccountCircle, */
            icon: mdiCog,
            label: '機能設定'
        },
        {
            to: '/faq',
            icon: mdiMessageQuestionOutline,
            label: `ユーザーマニュアル
よくある質問`,
            isBottom: true,
        },
        {
            icon: mdiForumOutline,
            label: 'お問い合わせ',
            isBottom: true,
        },
        {
            externalLink: 'https://spo-plus.com/shot/?utm_source=spo%2Btraining&utm_medium=referral&utm_campaign=member-page&utm_content=menu',
            img: shotSidebarBanner,
            isBottom: true,
        },
        // NOTE: 既存の画面を確認するためコメントアウトしています。
        /* {
            to: '/training',
            icon: mdiWeightLifter,
            label: 'トレーニング'
        },
        {
            to: '/evaluation',
            label: '測定結果一覧',
            icon: mdiTable,
            updateMark: true,
            showOnlyInTeam: true
        }, */
        /* {
            to: 'https://www.nextrainer.ooo/terms.html',
            label: '利用規約',
            icon: mdiFileDocumentMultipleOutline
        },
        {
            to: 'https://www.nextrainer.ooo/policy.html',
            label: 'プライバシーポリシー',
            icon: mdiShieldAccount
        } */
    ],
    // 'ユーザー',
    // [
    // {
    //     label: 'お問い合わせ',
    //     icon: mdiMessageQuestionOutline
    // },
    // {
    //     to: 'https://www.nextrainer.ooo/terms.html',
    //     label: '利用規約',
    //     icon: mdiFileDocumentMultipleOutline
    // },
    // {
    //     to: 'https://www.nextrainer.ooo/policy.html',
    //     label: 'プライバシーポリシー',
    //     icon: mdiShieldAccount
    // }
    // {
    //     label: 'Topに戻る',
    //     icon: mdiLogout
    // }
    // ]
]
